
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import SidemenuLayout from '@/components/organisms/layout/SidemenuLayout.vue'
import TitlePanel from '@/components/organisms/TitlePanel.vue'
import NoticeListPanel from '@/components/organisms/NoticeListPanel.vue'
import { SelectItem } from '@/models/SelectItem'
import { NoticeMessageData } from '@/models/NoticeMessage'

/**
 * お知らせ一覧ページのレイアウト
 */
@Component({
  components: {
    SidemenuLayout,
    TitlePanel,
    NoticeListPanel,
  },
})
export default class NoticeMessageList extends Vue {
  /** メッセージ一覧パネル */
  @Ref()
  noticeMessageListPanel!: NoticeListPanel

  /** お知らせタイプの初期値 */
  @Prop()
  private defaultNotificationTypeCode!: string

  /** お知らせタイプのリスト */
  @Prop()
  private notificationTypeList!: SelectItem[]

  /** メッセージ一覧 */
  @Prop()
  private messageList!: NoticeMessageData[]

  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private changePage!: (value: number) => void

  /** 行クリック時のイベント */
  @Prop()
  private eventClickElement!: (id: number) => void

  /**
   * 選択中のお知らせタイプ
   *
   * @returns お知らせタイプのコード
   */
  public currentNotificationTypeCode(): string {
    // undefinedケース 発生しないがブロックのため記述
    if (!this.noticeMessageListPanel) {
      return ''
    }
    return this.noticeMessageListPanel.currentNotificationTypeCode()
  }

  /** フィルターの変更を検知してイベント発火させる */
  private changeFilter(): void {
    this.$emit('changeFilter')
  }
}
